const useGetRateListDto = async (
  variables?: GraphqlQueryVariables,
  options?: GraphqlQueryOptions<GetRateListQuery, GetRateListQueryVariables>,
) => {
  const query = await useGraphqlQuery(GetRateListSchema, variables, options);

  const list = computed(() => {
    return query.result.value?.content?.rates?.list ?? null
  });

  const meta = computed(() => {
    return query.result.value?.content?.rates?.meta ?? null
  });

  return {
    ...query,
    list,
    meta,
  };
};

export { useGetRateListDto };
